export const THANKYOU = '/thankyou'
export const SUBSCRIBE = '/subscribe'
export const SUBSCRIBE2 = '/subscribe/quarter' // quarter plan
export const SUBSCRIBE3 = '/subscribe/offer' // monthly plan
export const SUBSCRIBE4 = '/subscribe/yearly' // year plan
export const SUBSCRIBE5 = '/subscribe/quarter-jul' // quarter Jul plan
export const SUBSCRIBE6 = '/subscribe/half-year' // half year plan
export const SUBSCRIBE7 = '/subscribe/yearly-100' // year plan - yearly-100
export const SUBSCRIBE8 = '/subscribe/monthly' // monthly plan
export const SIGN_UP = '/signup'
export const SIGN_IN = '/signin'
export const HOME = '/home'
export const PAYMENT = '/payment'
export const ACCOUNT = '/account'
export const ACCOUNT_PAYMENT = '/account-payment'
export const PASSWORD_CHANGE = '/change-password'
export const EMAIL_CHANGE = '/change-email'
export const PASSWORD_FORGET = '/password-forget'
export const NOTFOUND = '/404'
